import { allFacts } from '../constants';

export function getAvailableConditions(addedConditions: string[]) {
  const available = allFacts.filter(({ value }) => !addedConditions.includes(value));

  if (!available.length) return null;

  return available[0].value;
}
